import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Category from "./Category";
import TourCard from "./TourCard";
export default function TabsContainer({ tours, deleteTour }) {
  return (
    <>
      {/* first tab */}
      <div
        className="tab-pane fade show active"
        id="first-id"
        role="tabpanel"
        aria-labelledby="first-id-tab"
      >
        {/* filter and new */}
        <div className="d-flex m-4 flex-wrap">
          <div className="col-12 col-md-4 col-lg-6 ">
            <div
              className=" m-1 txt fs-15 cursor-pointer border round p-2"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
              </svg>
              فیلتر
            </div>
          </div>
          <Link to="/admin-panel/create-tour" className=" col-12 col-md-4 col-lg-6">
            <span className=" text-decoration-none color-black ">
              <div
                className="m-1 border p-2 round txt"
                style={{ fontSize: "15px" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={16}
                  height={16}
                  fill="currentColor"
                  className="bi bi-plus"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
                تور جدید
              </div>
            </span>
          </Link>
        </div>
        <div className="row">
          {tours.filter(value => value.main_status == 0).map((value, index) => {
            let colorIndex = index % 4;
            let colors =
              colorIndex == 0
                ? ["orange", "cream"]
                : colorIndex == 1
                ? ["green", "pale-green"]
                : colorIndex == 2
                ? ["blue", "pale-blue"]
                : ["purple", "pale-purple"];
            return <TourCard tour={value} colors={colors} deleteTour={deleteTour} />;
          })}
        </div>
      </div>
      {/* second tab */}
      <div
        className="tab-pane fade"
        id="second-id"
        role="tabpanel"
        aria-labelledby="second-id-tab"
      >
        {/* filter*/}
        <div className="d-flex m-4 flex-wrap">
          <div className="col-12 col-md-4 col-lg-6 ">
            <div
              className=" m-1 txt fs-15 cursor-pointer border round p-2"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
              </svg>
              فیلتر
            </div>
          </div>
        </div>
        <div className="row">
          {tours.filter(value => value.main_status == 4).map((value, index) => {
            let colorIndex = index % 4;
            let colors =
              colorIndex == 0
                ? ["orange", "cream"]
                : colorIndex == 1
                ? ["green", "pale-green"]
                : colorIndex == 2
                ? ["blue", "pale-blue"]
                : ["purple", "pale-purple"];
            return <TourCard tour={value} colors={colors} deleteTour={deleteTour} />;
          })}
        </div>
      </div>
      {/* third tab */}
      <div
        className="tab-pane fade"
        id="third-id"
        role="tabpanel"
        aria-labelledby="third-id-tab"
      >
        {/* filter*/}
        <div className="d-flex m-4 flex-wrap">
          <div className="col-12 col-md-4 col-lg-6 ">
            <div
              className=" m-1 txt fs-15 cursor-pointer border round p-2"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
              </svg>
              فیلتر
            </div>
          </div>
        </div>
        <div className="row">
          {tours.filter(value => value.main_status == 1).map((value, index) => {
            let colorIndex = index % 4;
            let colors =
              colorIndex == 0
                ? ["orange", "cream"]
                : colorIndex == 1
                ? ["green", "pale-green"]
                : colorIndex == 2
                ? ["blue", "pale-blue"]
                : ["purple", "pale-purple"];
            return <TourCard tour={value} colors={colors} deleteTour={deleteTour} />;
          })}
        </div>
      </div>
      {/* fourth tab */}
      <div
        className="tab-pane fade"
        id="fourth-id"
        role="tabpanel"
        aria-labelledby="fourth-id-tab"
      >
        <div className="d-flex m-4 flex-wrap">
          <div className="col-12 col-md-4 col-lg-6 ">
            <div
              className=" m-1 txt fs-15 cursor-pointer border round p-2"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
              </svg>
              فیلتر
            </div>
          </div>
        </div>
        <div className="row">
          {tours.filter(value => value.main_status == 2).map((value, index) => {
            let colorIndex = index % 4;
            let colors =
              colorIndex == 0
                ? ["orange", "cream"]
                : colorIndex == 1
                ? ["green", "pale-green"]
                : colorIndex == 2
                ? ["blue", "pale-blue"]
                : ["purple", "pale-purple"];
            return <TourCard tour={value} colors={colors} deleteTour={deleteTour} />;
          })}
        </div>
      </div>
      {/* fifth tab */}
      <div
        className="tab-pane fade"
        id="fifth-id"
        role="tabpanel"
        aria-labelledby="fifth-id-tab"
      >
        <div className="d-flex m-4 flex-wrap">
          <div className="col-12 col-md-4 col-lg-6 ">
            <div
              className=" m-1 txt fs-15 cursor-pointer border round p-2"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={16}
                height={16}
                fill="currentColor"
                className="bi bi-funnel"
                viewBox="0 0 16 16"
              >
                <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
              </svg>
              فیلتر
            </div>
          </div>
        </div>
        <div className="row">
          {tours.filter(value => value.main_status == 3).map((value, index) => {
            let colorIndex = index % 4;
            let colors =
              colorIndex == 0
                ? ["orange", "cream"]
                : colorIndex == 1
                ? ["green", "pale-green"]
                : colorIndex == 2
                ? ["blue", "pale-blue"]
                : ["purple", "pale-purple"];
            return <TourCard tour={value} colors={colors} deleteTour={deleteTour} />;
          })}
        </div>
      </div>
      <div className="tab-pane fade w-100" id="sixth-id">
        <div className="w-100">
          <Category />
        </div>
      </div>
    </>
  );
}
